<script setup lang="ts">
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const user = userStore.authenticatedUser
</script>

<template>
  <div
    :class="{
      heading: true,
      [user?.scanMode.toLowerCase() as string]: true,
    }"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.heading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 8px 12px;
  margin: 1dvh 0 1.5dvh;
  background-color: #f0f4f7;
  border-radius: 5px;

  &:deep(h2) {
    font-size: 18px;
    margin: 0;
  }
}
</style>
